import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../assets/global/globalStyles';
import { httpRequestWarehouseContact } from '../../../store/warehouseContact';
import { warehouseContactForm } from '../../../utils/formVerifications';
import Input from '../Input';
import { Container, Form, Title } from './styles';

export default function FormWarehouse({ id, closeModal }) {
  const formRef = React.useRef(null);
  const dispatch = useDispatch();

  const handleSubmit = async (data) => {
    formRef.current.setErrors({});
    const { payload, error } = await warehouseContactForm(data);
    if (error) return formRef.current.setErrors(error);
    if (payload) {
      const { success } = await dispatch(
        httpRequestWarehouseContact({
          url: '/warehouse/create-contact',
          method: 'POST',
          data: {warehouseId: id, ...payload },
        }),
      );
      if (success) closeModal(false);
    }
  };

  return (
    <Container>
      <Title>Cadastrar Contato</Title>
      <Form ref={formRef} autoComplete="off" onSubmit={handleSubmit}>
        <Input name="contactName" label="Nome do Responsável:*" />
        <Input name="phone" mask="(99) 99999-9999" label="Telefone:*" />
        <Input name="email" grid="1 / -1" label="Email:*" />
        <Button type="submit" typeName="success">
          Enviar
        </Button>
      </Form>
    </Container>
  );
}
